import * as z from 'zod';
import { VISITOR_CATEGORY_TYPE, ZONE_CAPACITY_TYPE, ZONE_TYPE } from 'src/features/zone/utils/types';

export type ZoneFormSchemaValues = z.infer<typeof zoneFormSchema>;
export const zoneFormSchema = z.object({
    translations: z
        .array(
            z.object({
                language: z.string(),
                name: z.string().nonempty(),
                description: z.string(),
            }),
        )
        .min(1),
    capacity_limits: z.array(
        z.object({
            visitor_categories: z.array(z.enum(ZONE_CAPACITY_TYPE)),
            spaces_count: z.number(),
        }),
    ),
    visitor_categories: z.array(z.enum(VISITOR_CATEGORY_TYPE)).min(1),
    type: z.enum(ZONE_TYPE).nonoptional(),
    total_spaces: z.number(),
    spaces_count: z.number().min(1),
    overflow_spaces: z.number().min(1),
    limit_access_per_capacity: z.boolean(),
    limit_user_access: z.boolean(),
    site: z.string().nonempty(),
    service_provider: z.string().nonempty(),
    parent_zone: z.string().optional(),
    user_access: z.array(z.string()),
});
